<template>
  <section class="title">
    <div class="container">
      <tituloGus>GUS_MACHADO.DWG</tituloGus>
      <p class="subtituloGus">{{ $t('projectsPage.subtituloGus') }}</p>
    </div>
  </section>
</template>

<style scoped>
.title {
  min-height: 0;
  background: var(--color-light);
  color: var(--color-bg-dark);
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 24px;
}

tituloGus {
  display: block;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.subtituloGus {
  margin-top: 6px;
  margin-bottom: 0;
}

@media (aspect-ratio <= 3/4) {
  .container {
    max-width: none;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  tituloGus,
  .subtituloGus {
    display: block;
    width: 100%;
  }

  tituloGus {
    font-size: clamp(40px, 12vw, 72px);
    line-height: 0.95;
  }
}
</style>
